import { render, staticRenderFns } from "./HeaderRoutinePrint.vue?vue&type=template&id=b865a60a"
import script from "./HeaderRoutinePrint.vue?vue&type=script&lang=js"
export * from "./HeaderRoutinePrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports